module.exports = __webpack_public_path__ + "static/main5-en-fcb1cd0224d37fa7f2c26b88c3527889.png";